// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckBox__container___3pUCo","checked":"CheckBox__checked___3JzjU","icon":"CheckBox__icon___2t0Pj","reversed":"CheckBox__reversed___1s_vy"};